export default "__VITE_ASSET__BsrzvrO5__"